<script lang="ts">
    import { Container,Row ,Col} from "sveltestrap";
    import { Copyright, Handcrafted } from "../../utils/Constant/Constant";
</script>
<footer class="footer" id="footer">
    <Container fluid>
      <Row>
        <Col md="6" class="footer-copyright">
          <p class="mb-0">{Copyright}</p>
        </Col>
        <Col md="6">
          <p class="pull-right mb-0"> {Handcrafted}<i class="fa fa-heart font-secondary"></i></p>
        </Col>
      </Row>
    </Container>
</footer>